import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { Box, Button, Typography } from '@mui/material';
import React, { useMemo } from 'react';

interface IProps {
  isFirstStep: boolean;
  isLastStep: boolean;
  isContinueDisabled: boolean;
  handleContinue: () => void;
}

export const ModalFooter: React.FC<IProps> = ({ isFirstStep, isLastStep, isContinueDisabled, handleContinue }) => {
  const showInfoMessage = useMemo(() => isFirstStep && isContinueDisabled, [isFirstStep, isContinueDisabled]);
  const buttonText = useMemo(() => (isLastStep ? 'Save & open builder' : 'Continue'), [isLastStep]);
  const buttonDataAction = useMemo(() => (isLastStep ? 'save_btn' : 'continue_btn'), [isLastStep]);

  const rowStyles = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
  };

  return (
    <>
      {showInfoMessage && (
        <Box sx={rowStyles}>
          <InfoOutlinedIcon fontSize="small" color="action" />
          <Typography variant="caption" color="text.secondary">
            Template name is required to continue
          </Typography>
        </Box>
      )}
      <Box sx={{ ...rowStyles, marginLeft: 'auto' }}>
        <Button
          variant="contained"
          size="small"
          onClick={handleContinue}
          disabled={isContinueDisabled}
          endIcon={!isLastStep && <NavigateNextIcon fontSize="small" />}
          data-action={buttonDataAction}
        >
          {buttonText}
        </Button>
      </Box>
    </>
  );
};
